import classnames from 'classnames';
import { CloseIcon } from 'components/icons/CloseIcon';
import { HTMLInputTypeAttribute, KeyboardEvent } from 'react';

interface IProps {
  disabled?: boolean;
  fullWidth?: boolean;
  icon?: JSX.Element;
  value: string;
  additionalClasses?: string;
  size: string;
  placeholder: string;
  type: HTMLInputTypeAttribute;
  name: string;
  border?: 'gray' | 'orange';
  onChange?: (e: string) => void;
  onKeydown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  lightMode?: boolean;
  showButton?: boolean;
}

const TextField = ({
  disabled,
  fullWidth,
  additionalClasses,
  size,
  name,
  icon,
  value,
  onChange,
  placeholder,
  border = 'gray',
  onKeydown,
  lightMode,
  showButton = true
}: IProps) => {
  const borderClass =
    border === 'gray'
      ? 'hover:border-gray-100 focus:border-gray-100'
      : 'hover:border-orange-700 focus:border-orange-700';

  return (
    <div className="w-full flex items-center relative">
      {icon}
      <input
        className={classnames(
          'rounded font-lato text-[13px] font-normal leading-[13px] w-full focus:outline-none py-0 placeholder-white',
          { 'w-full': fullWidth },
          { 'max-w-[500px]': !fullWidth },
          { 'px-7': size === 'large' },
          { 'px-4': size === 'medium' },
          { 'bg-white font-medium placeholder-gray-main border-gray-200': lightMode === true },
          { 'bg-gray-main hover:border focus:border': !lightMode },
          { 'bg-gray-50 border-gray-100 cursor-not-allowed': disabled },
          { 'pl-8': icon },
          borderClass,
          additionalClasses
        )}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e.target.value)}
        disabled={disabled}
        onKeyDown={onKeydown}
        autoComplete="off"
      />
      {showButton ? (
        <div className="flex absolute right-0 items-center">
          {value ? (
            <button
              className="px-4 border-r-[1px] text-gray-100 hover:text-white text-sm hidden sm:block"
              onClick={() => onChange && onChange('')}
            >
              Clear
            </button>
          ) : (
            <></>
          )}

          <CloseIcon
            className="mr-4 ml-4 w-5 h-5 cursor-pointer text-gray-100 hover:text-white"
            onClick={() => onChange && onChange('')}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TextField;
